/* eslint-disable react-refresh/only-export-components */
import { Spinner } from "@/assets/icons";
import { Navbar } from "@/components/navbar";
import { Footer } from "@/components/views";
import { PlainLayout, PlainLayoutProps } from "@/layout";
import { lazyImport } from "@/lib/utils";
import { ErrorPage } from "@/misc/error-page";
import { Toaster } from "@/providers";
import { RequireAuth } from "@/providers/auth";
import { RequireUser } from "@/providers/user";
import { Suspense } from "react";
import { Outlet, RouteObject } from "react-router-dom";
import ScrollToTop from "@/ScrollToTop";

const fallback = (
  <div className='h-screen grid place-items-center'>
    <Spinner size={28} />
  </div>
);

const Protected = ({ children }: { children: React.ReactNode }) => {
  return (
    <Suspense fallback={<h1>Loading...</h1>}>
      <RequireAuth>
        <RequireUser>{children}</RequireUser>
      </RequireAuth>
    </Suspense>
  );
};

// const App = () => {
//   return (
//     <Protected>
//       <UIProvider>
//         <AppLayout sidebar={<Sidebar />}>
//           <AppHeaderLayout>
//             <NavHeader />
//           </AppHeaderLayout>
//           <AppContentLayout>
//             <ScrollToTop />
//             <Suspense fallback={fallback}>
//               <Outlet />
//             </Suspense>
//           </AppContentLayout>
//         </AppLayout>
//       </UIProvider>
//     </Protected>
//   );
// };

const Plain = (props: PlainLayoutProps & { preventRedirect?: boolean }) => {
  return (
    <Suspense fallback={<h1>Loading...</h1>}>
      <RequireAuth>
        <RequireUser isOptional={props.preventRedirect}>
          <PlainLayout {...props}>
            <ScrollToTop />
            <Outlet />
          </PlainLayout>
        </RequireUser>
      </RequireAuth>
    </Suspense>
  );
};

// Store layout for protected ecommerce routes
const StoreLayout = () => {
  return (
    <Protected>
      <Navbar />
      <ScrollToTop />
      <Suspense fallback={fallback}>
        <Outlet />
      </Suspense>
      <Footer />
    </Protected>
  );
};

// Lazy imports for existing protected pages
const { Onboarding } = lazyImport(() => import("@/pages/protected"), "Onboarding");

// Lazy imports for ecommerce protected pages
const { Cart } = lazyImport(() => import("@/pages/protected"), "Cart");
const { Checkout } = lazyImport(() => import("@/pages/protected"), "Checkout");
const { OrderHistory } = lazyImport(() => import("@/pages/protected"), "OrderHistory");
const { Profile } = lazyImport(() => import("@/pages/protected"), "Profile");
const { OrderSuccess } = lazyImport(() => import("@/pages/protected"), "OrderSuccess");
const { Returns } = lazyImport(() => import("@/pages/protected"), "Returns");

const storeProtectedRoutes: RouteObject[] = [
  // {
  //   element: <App />,
  //   errorElement: <ErrorPage />,
  //   children: [
  //     {
  //       path: "/",
  //       element: <Home />,
  //     },
  //   ],
  // },
  {
    element: <Plain preventRedirect />,
    children: [{ path: "onboarding", element: <Onboarding /> }],
  },
  // Ecommerce protected routes
  {
    element: <StoreLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: "/cart", element: <Cart /> },
      { path: "/checkout", element: <Checkout /> },
      { path: "/order-success", element: <OrderSuccess /> },
      { path: "/orders", element: <OrderHistory /> },
      { path: "/returns", element: <Returns /> },
      {
        path: "/profile",
        element: <Profile />,
        children: [
          { path: "profile-settings", index: true, element: <h1>Settings</h1> },
          { path: "addresses", element: <h1>Addresses</h1> },
          { path: "password", element: <h1>Change Password</h1> },
          { path: "wishlist", element: <h1>Wishlist</h1> },
        ],
      },
    ],
  },
];

export const storeRoutes: RouteObject[] = [
  {
    element: (
      <>
        <ScrollToTop />
        <Outlet />
        <Toaster></Toaster>
      </>
    ),
    children: storeProtectedRoutes,
  },
];
